import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, of, Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthguardService {

  token = "Some token";

  constructor(private http: HttpClient) { }

  public bool_login: boolean = false;



  gettoken(){

    if (localStorage.getItem("logged_in") == "TRUE") {
      this.bool_login = true;
    } else {
      this.bool_login = false;
    }
    return this.bool_login;

    // return !!localStorage.getItem("SeesionUser");
    // }

    // verifyToken(): Observable<boolean> {
    //   const token = this.getToken();
    //   return token
    //     ? this.http.post("https://jsonplaceholder.typicode.com/users", { verify: this.token }).pipe(
    //         tap(res => (localStorage.data = JSON.stringify(res))),
    //         map(res => true, (error:any) => false)
    //       )
    //     : of(false);
    // }
  }

}
